import { useContext } from 'react';
import { TimerContext } from '../context/timer.context';

export const useTimer = () => {
  const context = useContext(TimerContext);
  if (context === undefined) {
    throw new Error(`Component is not inside TimerContext scope`);
  }
  return context;
};
